import { useScriptGoogleAnalytics, useScriptClarity, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const clarity = useScriptClarity({"id":"m6cj3807tp"})
    const googleAnalytics = useScriptGoogleAnalytics({"id":"G-JJZ7X4135X"})
    return { provide: { $scripts: { clarity, googleAnalytics } } }
  }
})